export const celsiusToFahrenheit = (celsius) => {
    if (!celsius || isNaN(celsius))
        return 0;
    const fahrenheit = (celsius * 9) / 5 + 32;
    return Math.round(fahrenheit * 10) / 10; // Round to 1 decimal point
};
